import { Settings } from "./Settings";
import {
    ICheckOptions,
    IReelTeasingAttributes,
    ISymbolTeasingAttributes,
    ReelTeasingActions,
    SymbolTeasingActions,
    TeasingComponent,
} from "./TeasingComponent";
import { PlayList } from "../Components/Sounds/PlayList";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../Utils/FrameTimer";

export class TeasingBonus extends TeasingComponent {
    _impactScatterCounter: number;
    _stopScatterCounter: number;

    private _delayedTeasingFaildSound: FrameTimerEventEmitter;

    private wildPositions: Array<Array<number>>;
    private wildIndex: number = 0;

    private _wildTimer: FrameTimerEventEmitter;

    private running: boolean = false;

    private luciferCallBack: (animation: number) => void;

    constructor() {
        super();

        //this.teasingStopDelay = 90;
        this.minimumSymbolsForTeasing = 2;

        this.teasingSymbol = Settings.SymbolTeasing;
        this.impactSymbols = Settings.SymbolsImpact;

        this._impactScatterCounter = 0;
        this._stopScatterCounter = 0;

        this._delayedTeasingFaildSound = CreateFrameTimer("delayedTeasingFaildSound");
        this._delayedTeasingFaildSound.on(FrameTimerEvents.Complete, this.delayedTeasingFaildSound.bind(this));

        this._wildTimer = CreateFrameTimer("teasingWildTimer");
        this._wildTimer.on(FrameTimerEvents.Complete, this.animateWilds.bind(this));
    }

    set customData(value: any) {}

    public spinStart(): void {
        this.outro();
    }

    private outro(force: boolean = false): void {
        if (this.running) {
            this._wildTimer.stop();
            if (force && this.elementInstance["teasingWilds"].hasCase("OUTRO_QUICK")) {
                this.elementInstance["teasingWilds"].goToCase("OUTRO_QUICK");
            } else if (this.elementInstance["teasingWilds"].hasCase("OUTRO")) {
                this.elementInstance["teasingWilds"].goToCase("OUTRO");
            }
            if (force && this.elementInstance["teasingBack"].hasCase("OUTRO_QUICK")) {
                this.elementInstance["teasingBack"].goToCase("OUTRO_QUICK");
            } else if (this.elementInstance["teasingBack"].hasCase("OUTRO")) {
                this.elementInstance["teasingBack"].goToCase("OUTRO");
            }
            if (this.wildPositions.length && this.elementInstance["teasingFront"] != null) {
                if (force && this.elementInstance["teasingFront"].hasCase("OUTRO_QUICK")) {
                    this.elementInstance["teasingFront"].goToCase("OUTRO_QUICK");
                } else if (this.elementInstance["teasingFront"].hasCase("OUTRO")) {
                    this.elementInstance["teasingFront"].goToCase("OUTRO");
                }
            }
            this.running = false;
        }
    }

    //******************************************************************************************************************
    //  CHECK REELS
    //******************************************************************************************************************

    /**
     * Check called before reel.spinStop(). Checks if teasing is possible and checks which reel can be stopped immediately.
     * @param {ICheckOptions} options
     */
    public checkOnInit(options: ICheckOptions): Array<IReelTeasingAttributes> {
        if (this.running) {
            if (options.force) {
                this.outro(true);
            }
            return this.reelsTeasingAttributes;
        }

        this.stoppedSymbolsArray = options.stoppedSymbols;
        this.force = options.force;
        let additionalDelay = 0;

        this.teasingEnabled = false;
        this.teasingEnabledForce = false;

        this.wildPositions = [];

        for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
            if (this.stoppedSymbolsArray[reelIndex].transform) {
                for (
                    let symbolIndex = 0;
                    symbolIndex < this.stoppedSymbolsArray[reelIndex].transform.length;
                    symbolIndex++
                ) {
                    if (this.stoppedSymbolsArray[reelIndex].transform[symbolIndex] != -1) {
                        this.wildPositions.push([reelIndex, symbolIndex]);
                    }
                }
            }
        }

        if (this.wildPositions.length > 0) {
            if (!options.force) {
                this.teasingEnabled = true;
            } else {
                this.teasingEnabledForce = true;
            }
            for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
                additionalDelay += this.teasingStopDelay;
                this.reelsTeasingAttributes[reelIndex].action = ReelTeasingActions.TEASE;
                this.reelsTeasingAttributes[reelIndex].stopDelay =
                    (this.wildPositions.length + 1) * this.teasingStopDelay + reelIndex * this.stopDelay;
            }
        } else {
            for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
                this.reelsTeasingAttributes[reelIndex].action = ReelTeasingActions.SPIN_STOP;
                this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay;
            }
        }

        // shuffle this.wildPositions array
        for (let i = this.wildPositions.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [this.wildPositions[i], this.wildPositions[j]] = [this.wildPositions[j], this.wildPositions[i]];
        }

        // todo: if force, don't animate with delay and skip to some state like INIT_FORCE?
        this.wildIndex = 0;
        if (this.wildPositions.length) {
            this.running = true;
            if (this.elementInstance["teasingWilds"].hasCase("INTRO")) {
                this.elementInstance["teasingWilds"].goToCase("INTRO");

                this.luciferCallBack(0);
            }
            if (this.elementInstance["teasingBack"].hasCase("INTRO")) {
                this.elementInstance["teasingBack"].goToCase("INTRO");
            }
            if (this.elementInstance["teasingFront"] != null) {
                this.elementInstance["teasingFront"].goToCase("INIT");
            }
        }

        if (this.wildPositions.length) {
            this._wildTimer.stop();
            this._wildTimer.start(this.teasingStopDelay);
        }

        return this.reelsTeasingAttributes;
    }

    public onLuciferWildAnimation(luciferCallBack: (animation: number) => void): void {
        this.luciferCallBack = luciferCallBack;
    }

    private animateWilds(): void {
        if (this.elementInstance["teasingWilds"]) {
            if (!this.wildPositions.length) {
                /*
                if(this.elementInstance['teasingWilds'].hasCase("RESET")) {
                    this.elementInstance['teasingWilds'].goToCase("RESET");
                }*/
            } else {
                if (this.wildIndex < this.wildPositions.length) {
                    let index =
                        this.wildPositions[this.wildIndex][0] * this._visibleSymbolCount +
                        this.wildPositions[this.wildIndex][1];
                    if (this.elementInstance["teasingWilds"].hasCase("ANIMATE_" + index)) {
                        this.elementInstance["teasingWilds"].goToCase("ANIMATE_" + index);

                        this.luciferCallBack(1);
                        this.elementInstance["teasingFront"].goToCase("THROW_WILD");
                    }
                    if (this.elementInstance["teasingBack"].hasCase("THROW_WILD")) {
                        this.elementInstance["teasingBack"].goToCase("THROW_WILD");
                    }
                    this.wildIndex++;
                    this._wildTimer.stop();
                    this._wildTimer.start(this.teasingStopDelay);
                } else {
                    this.outro();
                    this.luciferCallBack(2);
                }
            }
        }
    }

    //******************************************************************************************************************
    //  CHECK SYMBOLS TEASING
    //******************************************************************************************************************

    /**
     *
     * @param {number} reelIndex
     * @returns {Array<ISymbolTeasingAttributes>}
     */
    public checkSymbolsPerReel(reelIndex: number): Array<Array<ISymbolTeasingAttributes>> {
        let countOfSymbol = this.getCountSymbolsOnReelsAndRows(0, reelIndex, this.teasingSymbol);

        let preceeding = this.precedingReelsWithSymbols(reelIndex + 1, this.teasingSymbol);

        let bonus = preceeding == 3 && reelIndex + 1 == this.stoppedSymbolsArray.length;

        for (let reelNo = 0; reelNo < this.stoppedSymbolsArray.length; reelNo++) {
            for (let symbolNo = 0; symbolNo < this.stoppedSymbolsArray[reelNo].symbols.length; symbolNo++) {
                if (reelNo === reelIndex) {
                    // only current reel will show impact animations
                    if (this.stoppedSymbolsArray[reelNo].symbols[symbolNo] === this.teasingSymbol) {
                        // teasing symbols have different impact animation names
                        if (countOfSymbol > 0 && reelNo - this._impactScatterCounter === 2) {
                            // if enough scatter symbols happened before, tease
                            if (reelNo + 1 == this.stoppedSymbolsArray.length) {
                                this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.NORMAL;
                            } else {
                                this.symbolsTeasingAttributes[reelNo][symbolNo].action =
                                    SymbolTeasingActions.IMPACT_TEASE;
                                PlayList.play("SND_BaseRotationEndScatter" + ++this._stopScatterCounter);
                            }
                        } else {
                            // if not enough scatters happened, just impact
                            if (preceeding >= 2 && reelIndex >= 3 && reelIndex - preceeding === 1) {
                                this.symbolsTeasingAttributes[reelNo][symbolNo].action =
                                    SymbolTeasingActions.IMPACT_NOWIN;
                            } else {
                                this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.IMPACT;
                            }
                        }
                        this._impactScatterCounter++;
                    } else {
                        if (preceeding >= 2 && reelIndex >= 3 && reelIndex - preceeding === 1) {
                            this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.IMPACT_NOWIN;
                        } else {
                            this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.IMPACT;
                        }
                    }
                } else {
                    // regular symbols are...
                    if (reelIndex - preceeding > 1) {
                        // ...put into normal state if preceeding scatters mean teasing is NOT happening (teasing happened, but failed, so bonus will not happen)
                        if (this.stoppedSymbolsArray[reelNo].symbols[symbolNo] === this.teasingSymbol) {
                            this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.NO_CHANGE;
                        } else {
                            this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.NORMAL;
                        }
                    } else if (
                        preceeding == 2 &&
                        reelIndex >= 3 &&
                        this.stoppedSymbolsArray[reelNo].symbols[symbolNo] !== this.teasingSymbol
                    ) {
                        // ...put into nowin (dark) state if next reel starts teasing
                        this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.NOWIN;
                    } else if (preceeding == 3 && reelIndex + 1 == this.stoppedSymbolsArray.length) {
                        // preceeding tease symbols set to normal on last reel if bonus triggers, for quick stop interrupt
                        this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.NORMAL;
                    } else {
                        // ...not changed otherwise
                        this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.NO_CHANGE;
                    }
                }
            }
        }

        if (reelIndex === this.reelCount - 1) {
            this._impactScatterCounter = 0;
            this._stopScatterCounter = 0;
        }

        return this.symbolsTeasingAttributes;
    }

    //******************************************************************************************************************
    //  REELS TEASING ANIMATIONS
    //******************************************************************************************************************

    /**
     * Start animating teasing layers.
     * OBSOLETE
     * @param reelIndex
     */
    public animateTeasing(reelIndex: number): boolean {
        if (this.teasingEnabled) {
            //this.removeTeasing(false);

            if (this.reelsTeasingAttributes[reelIndex + 1] != null) {
                if (this.reelsTeasingAttributes[reelIndex + 1].action == ReelTeasingActions.TEASE) {
                    if (this.elementInstance["teasingParticles"] != null) {
                        this.elementInstance["teasingParticles"].alpha = 1;
                        this.elementInstance["teasingParticles"].visible = true;
                        if (
                            this.elementInstance["teasingParticles"].getCurrentCase() == "LOOP" &&
                            this.elementInstance["teasingParticles"].hasCase("CONTINUE_" + reelIndex)
                        ) {
                            this.elementInstance["teasingParticles"].x = 0;
                            this.elementInstance["teasingParticles"].y = 0;
                            this.elementInstance["teasingParticles"].goToCase("CONTINUE_" + reelIndex);
                        } else if (this.elementInstance["teasingParticles"].hasCase("INIT_" + reelIndex)) {
                            this.elementInstance["teasingParticles"].x = 0;
                            this.elementInstance["teasingParticles"].y = 0;
                            this.elementInstance["teasingParticles"].goToCase("INIT_" + reelIndex);
                        } else {
                            this.elementInstance["teasingParticles"].x = this.reelX[reelIndex + 1];
                            this.elementInstance["teasingParticles"].y = this.reelY[reelIndex + 1];
                            this.elementInstance["teasingParticles"].goToCase("INIT");
                        }
                    }

                    if (!this.wasPlayedTeaserSound) {
                        //PlayList.play('SND_BaseFSTeaser');
                        this.wasPlayedTeaserSound = true;
                    }
                } else if (this.reelsTeasingAttributes[reelIndex + 1].action == ReelTeasingActions.SPIN_STOP) {
                    this.removeTeasing(false);
                    return false;
                }
                return true;
            }

            let countSymbolsOnReelsAndRows = this.getCountSymbolsOnReelsAndRows(0, reelIndex, this.teasingSymbol);
            let countSymbolsOnCurrentReel = this.getCountSymbolsOnReelsAndRows(
                reelIndex,
                reelIndex,
                this.teasingSymbol,
            );

            /*
            if (countSymbolsOnCurrentReel) {
                if (countSymbolsOnReelsAndRows > 0 && countSymbolsOnReelsAndRows <=3) {
                    PlayList.play('SND_SymScatterStop01');
                } else if (countSymbolsOnReelsAndRows > 3) {
                    PlayList.play('SND_SymScatterStop03');
                }
            }*/
        } else {
            this.removeTeasing(false);
            return false;
        }
        return false;
    }

    /**
     * Remove teasing animations.
     * In case of enought teasing symbols count win sound is played else fail sound is played.
     *
     * @param {boolean} noWin
     */
    public removeTeasing(noWin: boolean): void {
        if (noWin) {
            PlayList.play("SND_BaseFSTeaserFail");
        }

        if (this.wasPlayedTeaserSound) {
            // PlayList.stop('SND_BaseFSTeaser');

            if (this.countSymbolsOnReelsAndRows > this.minimumSymbolsForTeasing) {
                if (!this.wasPlayedTeaserWinSound) {
                    // PlayList.play('SND_BaseFSTeaserWin');
                    this.wasPlayedTeaserWinSound = true;
                }
            } else {
                if (!this.wasPlayedTeaserFailSound) {
                    PlayList.play("SND_BaseFSTeaserFail");
                    this.wasPlayedTeaserFailSound = true;
                }
            }
        }

        if (this.elementInstance["teasingFront"] != null) {
            if (
                this.elementInstance["teasingFront"].getCurrentCase() !== "NORMAL" &&
                this.elementInstance["teasingFront"].getCurrentCase() !== "OUTRO"
            ) {
                this.elementInstance["teasingFront"].goToCase("OUTRO");
            }
        }
        if (this.elementInstance["teasingParticles"] != null) {
            if (
                this.elementInstance["teasingParticles"].getCurrentCase() !== "NORMAL" &&
                this.elementInstance["teasingParticles"].getCurrentCase() !== "OUTRO"
            ) {
                this.elementInstance["teasingParticles"].goToCase("OUTRO");
            }
        }
    }

    public finishTeasing(reelIndex?: number): void {
        // PlayList.stop('SND_BaseFSTeaser');

        let countSymbolsOnReelsAndRows = this.getCountSymbolsOnReelsAndRows(0, this.reelCount - 1, this.teasingSymbol);
        if (this.wasPlayedTeaserSound || (reelIndex == this.reelCount - 1 && this.teasingEnabledForce)) {
            if (countSymbolsOnReelsAndRows > this.minimumSymbolsForTeasing) {
                // PlayList.play('SND_BaseFSTeaserWin');
            } else {
                this._delayedTeasingFaildSound.start(30);
            }
        }

        super.finishTeasing();

        this.canPlayTeaserSound = false;
        this.wasPlayedTeaserSound = false;

        if (this.elementInstance["teasingFront"] != null) {
            if (
                this.elementInstance["teasingFront"].getCurrentCase() !== "NORMAL" &&
                this.elementInstance["teasingFront"].getCurrentCase() !== "OUTRO"
            ) {
                this.elementInstance["teasingFront"].goToCase("OUTRO");
            }
        }

        if (this.elementInstance["teasingParticles"] != null) {
            if (
                this.elementInstance["teasingParticles"].getCurrentCase() !== "NORMAL" &&
                this.elementInstance["teasingParticles"].getCurrentCase() !== "OUTRO"
            ) {
                this.elementInstance["teasingParticles"].goToCase("OUTRO");
            }
        }
    }

    public delayedTeasingFaildSound(): void {
        if (!this.force) {
            PlayList.play("SND_BaseFSTeaserFail", 0, true);
            this.wasPlayedTeaserFailSound = true;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/TeasingBonus.ts
 **/